document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-predictive-search]');
  var toggle = document.querySelector('[data-predictive-search-toggle]');
  if (!root || !toggle) return;

  var input = root.querySelector('[data-predictive-search-input]');
  var resultsEl = root.querySelector('[data-predictive-search-results]');
  var closers = root.querySelectorAll('[data-predictive-search-close]');
  var latestQuery = '';
  var debounceTimer;

  var ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (ch) { return ESCAPE_MAP[ch]; });
  }

  function open() {
    root.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    input.focus();
  }

  function close() {
    root.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    if (root.hidden) open(); else close();
  });
  closers.forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function thumb(url) {
    return url ? url.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_100x100$1$2') : '';
  }

  function renderResults(data) {
    var results = (data.resources && data.resources.results) || {};
    var products = results.products || [];

    if (!products.length) {
      resultsEl.innerHTML = '<p class="predictive-search__empty">No matches yet &mdash; press enter to see all results.</p>';
      resultsEl.hidden = false;
      return;
    }

    resultsEl.innerHTML = '<ul class="predictive-search__list">' + products.map(function (product) {
      var image = (product.featured_image && product.featured_image.url) || product.image || '';
      var imgTag = image
        ? '<img src="' + escapeHtml(thumb(image)) + '" alt="" width="48" height="48" loading="lazy">'
        : '';
      var price = product.price != null ? '$' + product.price : (product.price_min != null ? formatMoney(product.price_min) : '');
      return '<li><a href="' + escapeHtml(product.url) + '">' +
        imgTag +
        '<span class="predictive-search__item-info">' +
          '<span class="predictive-search__item-title">' + escapeHtml(product.title) + '</span>' +
          '<span class="predictive-search__item-price">' + escapeHtml(price) + '</span>' +
        '</span>' +
      '</a></li>';
    }).join('') + '</ul>';
    resultsEl.hidden = false;
  }

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(debounceTimer);

    if (!query) {
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(function () {
      latestQuery = query;
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection&resources[limit]=6')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (query !== latestQuery) return;
          renderResults(data);
        })
        .catch(function () { /* fail quietly */ });
    }, 250);
  });
});
